import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../Core/Store";

interface ChartOptionsSliceState {
  showFrequencies: boolean;
  showDurations: boolean;
  showNumberOfItems: string;
}

export const initialState: ChartOptionsSliceState = {
  showFrequencies: true,
  showDurations: false,
  showNumberOfItems: "10",
};

const chartOptionsSlice = createSlice({
  name: "chartoptions",
  initialState,
  reducers: {
    updateChartOptionsParams: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { updateChartOptionsParams } = chartOptionsSlice.actions;

export const getChartOptionsSelector = (state: RootState) => state.chartoptions;

export default chartOptionsSlice.reducer;
